import { render, staticRenderFns } from "./DashboardAppsRow.vue?vue&type=template&id=21ce3cc0&scoped=true&"
import script from "./DashboardAppsRow.vue?vue&type=script&lang=js&"
export * from "./DashboardAppsRow.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAppsRow.vue?vue&type=style&index=0&id=21ce3cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce3cc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ce3cc0')) {
      api.createRecord('21ce3cc0', component.options)
    } else {
      api.reload('21ce3cc0', component.options)
    }
    module.hot.accept("./DashboardAppsRow.vue?vue&type=template&id=21ce3cc0&scoped=true&", function () {
      api.rerender('21ce3cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/integrations/DashboardApps/DashboardAppsRow.vue"
export default component.exports